/**
 * Uzbek strings of the 09 redesign's inbox: `Murojaatlar` and the three-column `Suhbatlar`
 * (09 §6–§7, gap rows 4.1–4.13). Spread into `uz`, so a key here is a `TranslationKey` like any
 * other. Kept in its own file so the inbox work does not edit the shared dictionary line by line.
 */
export const uzInbox09 = {
  // ---------------------------------------------------------------- chips
  "inbox09.own.label": "Kimniki",
  "inbox09.own.mine": "Meniki",
  "inbox09.own.unclaimed": "Olinmagan",
  "inbox09.own.all": "Hammasi",
  "inbox09.state.label": "Holat",
  "inbox09.state.awaiting": "Javob kutmoqda",
  "inbox09.state.pending_draft": "AI javobi tasdiqda",
  "inbox09.state.overdue": "Kechikkan",
  "inbox09.state.closed": "Yopilgan",
  "inbox09.channel.label": "Kanal",
  "inbox09.channel.all": "Hammasi",
  "inbox09.channel.telegram": "Telegram",
  "inbox09.channel.instagram": "Instagram DM",
  "inbox09.channel.instagram_comment": "Instagram izoh",
  "inbox09.live": "Real vaqtda",
  "inbox09.liveRetrying": "Qayta ulanmoqda",
  "inbox09.search.label": "Suhbatlarni qidirish",
  "inbox09.search.placeholder": "Ism, telefon yoki xabar",
  "inbox09.section.inbox": "Suhbatlar",
  "inbox09.section.comments": "Instagram kommentlari",
  "inbox09.section.nav": "Suhbatlar va kommentlar",

  // ---------------------------------------------------------------- list rows
  "inbox09.list.label": "Suhbatlar ro'yxati",
  "inbox09.list.error": "Suhbatlar ro'yxatini yuklab bo'lmadi.",
  "inbox09.list.empty": "Bu bo'limda suhbat yo'q.",
  "inbox09.list.unknownClient": "Noma'lum mijoz",
  "inbox09.list.unread": "{count} ta o'qilmagan",
  "inbox09.list.aiMark": "AI javob beradi",
  "inbox09.list.claim": "Olish",
  "inbox09.list.pick": "{name} ni tanlash",
  "inbox09.list.waiting": "Kutmoqda: {time}",
  "inbox09.retry": "Qayta urinish",
  "inbox09.time.now": "hozir",
  "inbox09.time.minutes": "{count} daq",
  "inbox09.time.hours": "{hours} soat {minutes} daq",
  "inbox09.time.yesterday": "kecha",
  "inbox09.claim.done": "Suhbat sizga o'tdi.",
  "inbox09.claim.taken": "Bu suhbatni {name} allaqachon oldi.",
  "inbox09.claim.failed": "Suhbatni olib bo'lmadi.",
  "inbox09.comment.kind": "Instagram izoh",
  "inbox09.comment.status": "Javob kutmoqda",
  "inbox09.comment.empty": "Javob kutayotgan izoh yo'q.",
  "inbox09.comment.error": "Izohlarni yuklab bo'lmadi.",

  // ---------------------------------------------------------------- murojaatlar
  "inbox09.queue.title": "Murojaatlar",
  "inbox09.queue.tableLabel": "Erkin navbatdagi murojaatlar",
  "inbox09.queue.col.client": "Mijoz",
  "inbox09.queue.col.need": "AI aniqlagan ehtiyoj",
  "inbox09.queue.col.wait": "Kutmoqda",
  "inbox09.queue.col.actions": "Amallar",
  "inbox09.queue.empty": "Erkin navbatda murojaat yo'q.",
  "inbox09.queue.error": "Murojaatlarni yuklab bo'lmadi.",
  "inbox09.queue.needNone": "Ehtiyoj hali aniqlanmagan",
  "inbox09.queue.filterBranch": "Filial",
  "inbox09.queue.allBranches": "Barcha filiallar",
  "inbox09.queue.assign": "Biriktirish",
  "inbox09.queue.assignTitle": "Murojaatni biriktirish",
  "inbox09.queue.assignPick": "Xodim",
  "inbox09.queue.assignDone": "Murojaat {name} ga biriktirildi.",
  "inbox09.queue.assignFailed": "Biriktirib bo'lmadi.",
  "inbox09.queue.claimed": "Murojaat sizga o'tdi.",
  "inbox09.need.destination": "Yo'nalish",
  "inbox09.need.dates": "Sanalar",
  "inbox09.need.adults": "{count} kattalar",
  "inbox09.need.children": "{count} bola",
  "inbox09.need.service": "Xizmat",
  "inbox09.need.byAi": "AI aniqlagan",

  // ---------------------------------------------------------------- thread header
  "inbox09.header.handover": "Boshqaga berish",
  "inbox09.header.createDeal": "Bitim yaratish",
  "inbox09.header.close": "Yopish",
  "inbox09.header.closed": "Suhbat yopildi.",
  "inbox09.header.closeFailed": "Suhbatni yopib bo'lmadi.",
  "inbox09.header.dealCreated": "Bitim yaratildi.",
  "inbox09.header.dealExists": "Mijozning ochiq bitimi bor, suhbat unga bog'landi.",
  "inbox09.header.dealFailed": "Bitim yaratib bo'lmadi.",
  "inbox09.header.handoverTitle": "Suhbatni boshqaga berish",
  "inbox09.header.handoverPick": "Kimga",
  "inbox09.header.handoverSubmit": "Berish",
  "inbox09.header.handoverDone": "Suhbat {name} ga berildi.",
  "inbox09.header.handoverFailed": "Suhbatni berib bo'lmadi.",
  "inbox09.header.membersError": "Xodimlar ro'yxatini yuklab bo'lmadi.",
  "inbox09.header.cancel": "Bekor qilish",

  // ---------------------------------------------------------------- the draft and the bubbles
  "inbox09.draft.label": "AI javobi tasdiqda",
  "inbox09.draft.source": "Manba: {sources}",
  "inbox09.draft.noSource": "Manba: bilim bazasidan iqtibos yo'q",
  "inbox09.draft.send": "Yuborish",
  "inbox09.draft.edit": "Tahrirlash",
  "inbox09.draft.reject": "Rad etish",
  "inbox09.draft.rejectReason": "Rad etish sababi",
  "inbox09.draft.rejectPlaceholder": "Nima noto'g'ri?",
  "inbox09.draft.sendFailed": "Qoralamani yuborib bo'lmadi.",
  "inbox09.draft.rejectFailed": "Qoralamani rad etib bo'lmadi.",
  "inbox09.draft.notYours": "Javobni suhbatni olgan xodim tasdiqlaydi.",
  "inbox09.bubble.aiSent": "AI yubordi · {time}",
  "inbox09.bubble.approvedBy": "{name} tasdiqladi",
  "inbox09.bubble.client": "Mijoz xabari",
  "inbox09.note.label": "Ichki izoh",
  "inbox09.note.hidden": "(mijoz ko'rmaydi)",

  // ---------------------------------------------------------------- composer
  "inbox09.composer.template": "Shablon",
  "inbox09.composer.tour": "Tur biriktirish",
  "inbox09.composer.checklist": "Hujjat ro'yxati",
  "inbox09.composer.note": "Ichki izoh",
  "inbox09.composer.file": "Fayl",
  "inbox09.composer.noteOn": "Ichki izoh: jamoa ko'radi, mijozga bormaydi.",
  "inbox09.composer.notePlaceholder": "Jamoa uchun izoh",
  "inbox09.composer.saveNote": "Izohni saqlash",
  "inbox09.composer.noteFailed": "Izohni saqlab bo'lmadi.",
  "inbox09.composer.checklistFailed": "Hujjatlar ro'yxatini olib bo'lmadi.",

  // ---------------------------------------------------------------- right panel
  "inbox09.panel.label": "Mijoz ma'lumoti",
  "inbox09.panel.error": "Ma'lumotni yuklab bo'lmadi.",
  "inbox09.panel.noClient": "Mijoz aniqlanmagan",
  "inbox09.panel.source": "Manba",
  "inbox09.panel.firstContact": "Birinchi murojaat",
  "inbox09.panel.returning": "Qaytgan mijoz",
  "inbox09.panel.need": "AI aniqlagan ehtiyoj",
  "inbox09.panel.needEmpty": "Hali aniqlanmagan",
  "inbox09.panel.createDealWithNeed": "Shu ma'lumot bilan bitim yaratish",
  "inbox09.panel.visa": "Hujjatlar",
  "inbox09.panel.visaProgress": "({passed} / {total})",
  "inbox09.panel.sendChecklist": "Hujjatlar ro'yxatini yuborish",
  "inbox09.panel.trips": "Oldingi sayohatlar",
  "inbox09.panel.tripsEmpty": "Avval sayohat qilmagan",
  "inbox09.panel.tasks": "Vazifalar",
  "inbox09.panel.tasksEmpty": "Ochiq vazifa yo'q",
  "inbox09.panel.addTask": "+ Vazifa qo'shish",
  "inbox09.panel.call": "Qo'ng'iroq",
  "inbox09.panel.card": "Mijoz kartasi",

  // ---------------------------------------------------------------- a comment in the inbox
  "inbox09.commentView.label": "Instagram izoh",
  "inbox09.commentView.post": "Postni ochish",
  "inbox09.commentView.public": "Ochiq javob",
  "inbox09.commentView.direct": "Direktga o'tkazish",
  "inbox09.commentView.text": "Javob matni",
  "inbox09.commentView.publicSent": "Ochiq javob yuborildi.",
  "inbox09.commentView.directSent": "Direktga xabar yuborildi.",
  "inbox09.commentView.failed": "Javobni yuborib bo'lmadi.",
} as const;
